import { autoinject } from 'aurelia-framework';
import { NetlogHttpClient } from 'lib/http';
import { CustomerDocumentsHandler, CustomerDocumentsHandlerArgs } from './customer-documents-handler';
import { MooringDocumentsHandler, MooringDocumentsHandlerArgs } from './mooring-documents-handler';
import { MooringOrderDocumentsHandler, MooringOrderDocumentsHandlerArgs } from './mooring-order-documents-handler';
import { MooringOfferDocumentsHandler, MooringOfferDocumentsHandlerArgs } from './mooring-offer-documents-handler';
import {
  PenDimensionPipeSegmentDocuemntsHandler,
  PenDimensionPipeSegmentDocuemntsHandlerArgs,
} from './pen-dimension-pipe-segment-documents-handler';
import { ToastService } from 'services/toast-service';

@autoinject()
export class AttachmentHandlerFactory {
  constructor(private httpClient: NetlogHttpClient, private toastService: ToastService) {}

  public customerAttachmentHandler(args: CustomerDocumentsHandlerArgs) {
    return new CustomerDocumentsHandler(this.httpClient, args);
  }

  public mooringAttachmentHandler(args: MooringDocumentsHandlerArgs) {
    return new MooringDocumentsHandler(this.httpClient, args);
  }

  public mooringOrderAttachmentHandler(args: MooringOrderDocumentsHandlerArgs) {
    return new MooringOrderDocumentsHandler(this.httpClient, args);
  }

  public mooringOfferDocumentsHandler(args: MooringOfferDocumentsHandlerArgs) {
    return new MooringOfferDocumentsHandler(this.httpClient, args, this.toastService);
  }

  public penDimensionPipeSegmentHandler(args: PenDimensionPipeSegmentDocuemntsHandlerArgs) {
    return new PenDimensionPipeSegmentDocuemntsHandler(this.httpClient, args);
  }
}
